import { track } from '../facade';
import memoize from 'lodash/memoize';

const dispatch = (action, productId, value) =>
  track(action, {
    category: `Product Preview Zoom`,
    label: productId,
    value,
  });

export const trackZoomActivate = memoize((productId, pageIdx) => dispatch('Activate Zoom', productId, `Page index: ${pageIdx}`));
export const trackZoomClose = memoize(productId => dispatch('Close Zoom', productId));

export const trackZoomNext = memoize((productId, pageIdx) => dispatch('Click Next', productId, `Page index: ${pageIdx}`));
export const trackZoomPrev = memoize((productId, pageIdx) => dispatch('Click Previous', productId, `Page index: ${pageIdx}`));



// WEBPACK FOOTER //
// ./src/client/js/analytics/category/zoom.js